module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showWarning) ? _c('div', {
    staticClass: "session-timeout-wrapper"
  }, [_c('div', {
    staticClass: "backdrop"
  }), _vm._v(" "), _c('div', {
    staticClass: "warning-modal"
  }, [_c('strong', [_vm._v("Inaktivitet")]), _vm._v(" "), _c('p', [_vm._v("Din session håller på att gå ut på grund av inaktivitet.")]), _vm._v(" "), _c('div', {
    staticClass: "timer-display"
  }, [_c('div', {
    staticClass: "countdown"
  }, [_vm._v(_vm._s(_vm.formattedTime))])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.extending
    },
    on: {
      "click": _vm.extendSession
    }
  }, [_vm._v("\n        " + _vm._s(_vm.extending ? 'Förlänger...' : 'Förläng session') + "\n      ")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ab8ad42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/SessionTimeoutWarning.vue
// module id = 996
// module chunks = 0